// // AddToCartButton.jsx
// import React, { useState } from 'react';
// import { ShoppingCart, Check, Loader2 } from 'lucide-react';

// const AddToCartButton = ({ onClick }) => {
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);

//   const handleClick = async (e) => {
//     e.stopPropagation();
//     setLoading(true);
//     try {
//       await onClick();
//       setSuccess(true);
//       setTimeout(() => {
//         setSuccess(false);
//       }, 2000);
//     } catch (error) {
//       console.error('Error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <button
//       onClick={handleClick}
//       disabled={loading}
//       className={`
//         w-full py-3 px-4 rounded-lg
//         flex items-center justify-center gap-2
//         transition-all duration-300 transform
//         ${loading || success
//           ? 'bg-gray-800 text-white'
//           : 'bg-gray-900 text-white hover:bg-gray-800 hover:scale-[1.02]'
//         }
//         disabled:cursor-not-allowed
//         group
//       `}
//     >
//       {loading ? (
//         <>
//           <Loader2 className="w-5 h-5 animate-spin" />
//           <span>Adding...</span>
//         </>
//       ) : success ? (
//         <>
//           <Check className="w-5 h-5 text-green-400" />
//           <span>Added to Cart!</span>
//         </>
//       ) : (
//         <>
//           <ShoppingCart className="w-5 h-5 group-hover:rotate-12 transition-transform" />
//           <span>Add to Cart</span>
//         </>
//       )}
//     </button>
//   );
// };

// export default AddToCartButton;

import React, { useState } from "react";
import { ShoppingCart, Check, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";

const AddToCartButton = ({ onClick }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const navigate = useNavigate();

  const handleClick = async (event) => {
    // Check if event exists and is not null before calling stopPropagation
    if (event && typeof event.stopPropagation === "function") {
      event.stopPropagation();
    }

    setLoading(true);
    try {
      // Pass the event to onClick if needed
      if (auth.currentUser) {
        await onClick(event);
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 1000);
      } else {
        setShowAuthDialog(true);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loading}
        className={`
        w-full py-3 px-4 rounded-lg
        flex items-center justify-center gap-2
        transition-all duration-300 transform
        ${
          loading || success
            ? "bg-purple-800 text-white"
            : "bg-purple-900 text-white hover:bg-purple-800 hover:scale-[1.02]"
        }
        disabled:cursor-not-allowed
        group
        shadow-md hover:shadow-lg
      `}
      >
        {loading ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            <span>Adding...</span>
          </>
        ) : success ? (
          <>
            <Check className="w-5 h-5 text-purple-200" />
            <span>Added to Cart!</span>
          </>
        ) : (
          <>
            <ShoppingCart className="w-5 h-5 group-hover:rotate-12 transition-transform" />
            <span>Add to Cart</span>
          </>
        )}
      </button>
      {showAuthDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Sign in to continue
            </h2>
            <p className="text-gray-600 mb-6">
              Please sign in to access your wishlist, cart, and profile.
            </p>
            <div className="space-y-4">
              <button
                className="w-full bg-purple-800 hover:bg-purple-700 text-white py-2 px-4 rounded-lg transition-colors duration-200"
                onClick={() => {
                  setShowAuthDialog(false);
                  navigate("/login");
                }}
              >
                Sign In
              </button>
              <button
                className="w-full border border-gray-300 hover:border-gray-400 text-gray-700 py-2 px-4 rounded-lg transition-colors duration-200"
                onClick={() => {
                  setShowAuthDialog(false);
                  navigate("/register");
                }}
              >
                Create Account
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddToCartButton;
